export enum SlotRefundModeType {
  Interpolated = 'Interpolated',
  WholeSlots = 'WholeSlots',
}

/** Matches API `settings::UnusedTimeRefund` (camelCase on the wire). */
export interface UnusedTimeRefund {
  enabled: boolean
  slotRefundMode: { type: SlotRefundModeType }
}

export function defaultSlotRefundMode(): UnusedTimeRefund['slotRefundMode'] {
  return { type: SlotRefundModeType.Interpolated }
}

export function parseSlotRefundModeType(
  value: unknown
): SlotRefundModeType {
  if (value === SlotRefundModeType.WholeSlots) {
    return SlotRefundModeType.WholeSlots
  }
  return SlotRefundModeType.Interpolated
}
